import { render, staticRenderFns } from "./Clubs_list.vue?vue&type=template&id=0da8c756&scoped=true&"
import script from "./Clubs_list.vue?vue&type=script&lang=js&"
export * from "./Clubs_list.vue?vue&type=script&lang=js&"
import style0 from "./Clubs_list.vue?vue&type=style&index=0&id=0da8c756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8c756",
  null
  
)

export default component.exports